import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetIsUseBonuses = IAction<ETicketPayment.SET_IS_USE_BONUSES, boolean>

const setIsUseBonuses = (isUse: boolean): TSetIsUseBonuses => ({
    type: ETicketPayment.SET_IS_USE_BONUSES,
    payload: isUse,
});

export default setIsUseBonuses;
